import { ReactNode, useEffect, useState } from 'react';
export type PageContentRowProps = {
  children: ReactNode;
  classes?: string;
  noRightPadding?: boolean;
  noLeftPadding?: boolean;
};

export const PageContent = ({
  children,
  classes = '',
  noRightPadding,
  noLeftPadding,
}: PageContentRowProps) => {
  const [extraClasses, setExtraClasses] = useState<string>('');
  useEffect(() => {
    let extra: string = noLeftPadding ? ' pl-0 ' : '';
    extra += noRightPadding ? ' pr-0 ' : '';
    setExtraClasses(extra);
  }, [noLeftPadding, noRightPadding]);
  return (
    <div className={`page-content ${extraClasses} ${classes}`}>{children}</div>
  );
};
